import { useEffect, useState } from "react";

/*
  오늘 작업 집계 — /api/safety-report/work-summary.

  두 화면(오른쪽 «오늘 작업» 카드, 가운데 «안전 현황»판)이 같은 값을 쓴다.
  각자 부르면 같은 요청이 두 번 나가므로 훅 하나로 모았다.

  돌려주는 것
    counts        : { total, done, working, waiting, rescheduled }
    byVehicle     : [{ vehicle, worker, total, done }]  — 작업자(차량)별
    byType        : [{ workType, total, done }]         — 실외/용접 등
    jobCompliance : { total, violationJobs, compliantJobs, rate }
                    «작업 N건 중 M건에서 위반» — 작업 단위 준수율(REQ-035)
*/
function pad2(n) {
  return String(n).padStart(2, "0");
}
function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export default function useWorkSummary({ enabled = true, refreshMs = 60000 } = {}) {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let dead = false;

    const load = async () => {
      try {
        const d = todayIso();
        const res = await fetch(`/api/safety-report/work-summary?from=${d}&to=${d}`, {
          credentials: "include",
          cache: "no-store",
        });
        if (!res.ok) throw new Error(String(res.status));
        const j = await res.json();
        if (!dead) {
          setData(j);
          setFailed(false);
        }
      } catch {
        if (!dead) setFailed(true);
      }
    };

    load();
    const t = setInterval(load, refreshMs);
    return () => {
      dead = true;
      clearInterval(t);
    };
  }, [enabled, refreshMs]);

  return { data, failed };
}
